import { Stack, Typography } from '@mui/material';

const NoData = ({ message }) => (
  <Stack data-testid="NoData" sx={{ py: 4, alignItems: 'center', justifyContent: 'center' }}>
    <Typography>{message}</Typography>
  </Stack>
);

export default NoData;
